import React from "react";
import resume from "../data/resume.json";

const ContactLinks: React.FC = () => (
  <div className="contact-links">
    <a className="contact-link" href={`mailto:${resume.email}`}>
      <span className="contact-link-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 6 9-6" />
        </svg>
      </span>
      <span className="contact-link-text">
        <span className="contact-link-label">Email</span>
        <span className="contact-link-value">{resume.email}</span>
      </span>
    </a>
    <a
      className="contact-link"
      href={resume.linkedin}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="contact-link-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
          <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.75h4v11H3v-11Zm6.5 0h3.8v1.5h.06c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.77 2.65 4.77 6.1v5.46h-4v-4.84c0-1.15-.02-2.64-1.6-2.64-1.62 0-1.86 1.26-1.86 2.56v4.92h-4v-11Z" />
        </svg>
      </span>
      <span className="contact-link-text">
        <span className="contact-link-label">LinkedIn</span>
        <span className="contact-link-value">linkedin.com/in/robyn-severson</span>
      </span>
    </a>
  </div>
);

export default ContactLinks;
